import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/shared/api/queryKeys';
import { overviewConfigApi } from '../api/deploymentSettings.api';

export function useOverviewConfig(depId) {
  return useQuery({
    queryKey: queryKeys.overviewConfig.detail(depId),
    queryFn: () => overviewConfigApi.get(depId),
    enabled: !!depId,
    staleTime: 60_000,
  });
}

export function useSaveOverviewConfig(depId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => overviewConfigApi.put(depId, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.overviewConfig.detail(depId) }),
  });
}
